import { ShipperPermissionState } from './shipper-permission.types';

export const SHIPPER_PERMISSION_REQUEST = 'SHIPPER_PERMISSION_REQUEST';
export const SHIPPER_PERMISSION_RESPONSE = 'SHIPPER_PERMISSION_RESPONSE';

export interface ShipperPermissionResponseAction {
  type: typeof SHIPPER_PERMISSION_RESPONSE;
  payload: ShipperPermissionState;
}

export interface ShipperPermissionRequestAction {
  type: typeof SHIPPER_PERMISSION_REQUEST;
  payload: ShipperPermissionState;
}

export type ShipperPermissionActions =
  | ShipperPermissionResponseAction
  | ShipperPermissionRequestAction;
